import TableContainer from 'Common/TableContainer';
import { set } from 'date-fns';
import { addProduct, addProductVariant, getBrands, getCategoryList, getPackagings, getProductList, getProductSizes, getSeasons, updateProductVariant } from 'helpers/backend_helper';
import { Search } from 'lucide-react';
import React, { useEffect, useMemo, useState } from 'react';
import * as XLSX from 'xlsx';
import { Loader2 } from "lucide-react";


export const BulkUploadProduct = () => {


  const [categories, setCategories] = useState<any[]>([]);
  const [productSizes, setProductSizes] = useState<any[]>([]);
  const [seasons, setSeasons] = useState<any[]>([]);
  const [packagings, setPackagings] = useState<any[]>([]);
  const [excelData, setExcelData] = useState<any>(null);
  const [productData, setProductData] = useState<any>();
  const [brands, setBrands] = useState<any[]>([]);
  const [keys, setKeys] = useState<any[]>([]);
  const [productList, setProductList] = useState([]);
  const [excelProductList, setExcelProductList] = useState<any[]>([]);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [saveProgress, setSaveProgress] = useState({ current: 0, total: 0 });

  useEffect(() => {
    loadCategories();
    loadBrands();
    loadProductSizes();
    loadSeasons();
    loadPackagings();
    loadProducts();
  }, [])


  async function loadProducts() {
    try {
      if (productList.length === 0) {

        let response = await getProductList();
        if (response.success) {
          console.log('product', response.data);
          setProductList(response.data as never[]);
        }
      }
    } catch (error) {

    } finally {
    }
  }

  const loadBrands = async () => {
    if (brands.length === 0) {
      try {
        const response = await getBrands();
        if (response.success) {
          const brandItems = [{ value: '', label: 'Select', discount: 0 }, ...response.data.map((item: any) => ({ value: item.id, label: item.name, discount: item.discount }))];
          setBrands(brandItems);
        }
      } catch (error) {
        console.log("error in loadBrands", error);
      }
    }
  };


  const loadCategories = async () => {
    if (categories.length === 0) {
      try {
        const response = await getCategoryList();
        const categoryItems = response.data.map((item: any) => ({ value: item.id, label: item.name, }));
        setCategories([{ value: '', label: 'Select' }, ...categoryItems,]);
      } catch (error) {
        console.log("error in loadCategories", error);
      }
    }
  }


  const loadProductSizes = async () => {
    if (productSizes.length === 0) {
      try {
        const response = await getProductSizes();
        const prodSizes = response.data.map(({ id, name }) => ({ value: id, label: name }));
        setProductSizes(prodSizes);

      } catch { }
    }
  };


  const loadSeasons = async () => {
    if (seasons.length === 0) {
      try {
        const response = await getSeasons();
        const items = [{ value: '', label: 'Select' }, ...response.data.map(({ id, name }) => ({ value: id, label: name }))];
        setSeasons(items);

      } catch { }
    }
  };


  const loadPackagings = async () => {
    if (packagings.length === 0) {
      try {
        const response = await getPackagings();
        const items = response.data.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));
        setPackagings([{ value: '', label: 'Select' }, ...items]);

      } catch { }
    }
  };



  const handleFileUpload = (e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsLoading(true);
    const reader = new FileReader();

    reader.onload = (event: any) => {
      const workbook = XLSX.read(event.target.result, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet);
      setExcelData(sheetData);
      const keys = sheetData.length > 0 ? Object.keys(sheetData[0] as any) : [];
      setKeys(keys);
    };
    reader.onerror = () => {
      setIsLoading(false);
    };
    reader.readAsBinaryString(file);
  };


  useEffect(() => {
    if (excelData) {
      if (excelData.length > 0) {
        handleImport();
      } else {
        setIsLoading(false);
      }
    }
  }, [excelData]);


  const handleImport = async () => {
    setIsLoading(true);
    await new Promise(resolve => setTimeout(resolve, 0));
    console.log('handleImport', excelData);
    if (excelData) {
      // loop thru the excel data and add new fields
      console.log('categories', categories, brands, seasons, productSizes);

      let products: any[] = [];

      excelData.forEach(async (item: any) => {
        console.log('item', item);

        const brand = brands.find(({ label }) => label?.toUpperCase() === (item['Brand']?.toString() || '').toUpperCase().trim());
        const category = categories.find(({ label }) => label?.toUpperCase() === (item['Category']?.toString() || '').toUpperCase().trim());
        const season = seasons.find(({ label }) => label?.toUpperCase() === (item['Season']?.toString() || '').toUpperCase().trim());
        const size = productSizes.find(({ label }) => label?.toUpperCase().trim() === (item['SizeGroups']?.toString() || '').toUpperCase().trim());

        item.brandId = brand?.value || 0;
        item.categoryId = category?.value || 0;
        item.seasonId = season?.value || 0;
        item.sizeId = size?.value || 0;

        item.availableFrom = '01/01/2025';
        item.availableTo = '12/31/2035';
        item.productColor = ["#eeeeee"];
        item.colorName = "Gray";
        item.colorCode = "#eeeeee";
        item.name = [
            item['Category']?.toString()?.trim() || '',
            item['Brand']?.toString()?.trim() || '',
            item['StyleNo']?.toString()?.trim() || ''
        ].filter(Boolean).join(' ');

        item.packagingId = 1;
        item.productTags = ["Garmenzo"];

        item.attributes = [
          {
            "attribute": {
              "value": "1",
              "label": "Material"
            },
            "attributeValue": {
              "value": "8",
              "label": "Cotton"
            }
          }
        ];
        item.publish = true;
        item.isActive = true;
        console.log('item1', item);

        const unitPrice = item['UnitPrice']?.toString()?.trim() || 0;
        const buyingPrice = item['BuyingPrice']?.toString()?.trim() || 0;
        const discountPercent = item['Discount']?.toString()?.trim() || 0;
        const discountValue = Math.round(((unitPrice / 100) * discountPercent) * 100) / 100.00;
        item.Gender = item.Gender?.toString()?.toUpperCase()?.trim();
        item.Gender = ['MALE', 'BOYS', 'BOY'].includes(item.Gender) ? 'Boys' : ['FEMALE', 'GIRLS', 'GIRL'].includes(item.Gender) ? 'Girls' : 'Unisex';

        // check if the product already exists in ProductList

        const existingProduct = productList.find((p: any) => p.sku === item.SKU) as any || null;
        const prodId = existingProduct && existingProduct['id'] || 0;
        const existingVariant = existingProduct?.productsProductvariants?.find((p: any) => p.sizeId === item.sizeId);
        const variantId = existingVariant?.id || 0;
        const existingInventory = existingVariant?.inventory ?? 0;

        // NewStock: add to existing inventory. Inventory: override. API only has inventory.
        const newStockStr = item['NewStock']?.toString()?.trim();
        const inventoryStr = item['Inventory']?.toString()?.trim();
        const hasNewStock = newStockStr !== '' && newStockStr !== undefined && newStockStr !== null;
        const hasInventory = inventoryStr !== '' && inventoryStr !== undefined && inventoryStr !== null;

        let inventory: number;
        if (hasNewStock) {
          inventory = existingInventory + (parseInt(newStockStr, 10) || 0);
        } else if (hasInventory) {
          inventory = parseInt(inventoryStr, 10) || 0;
        } else {
          inventory = existingInventory;
        }

        const product = {
          attributes: [
            {
              attribute: {
                value: 1,
                label: "Material"
              },
              attributeValue: {
                value: 8,
                label: "Cotton"
              }
            }
          ],
          availableFromDate: item.availableFrom?.toString()?.trim(),
          availableToDate: item.availableTo?.toString()?.trim(),
          brandId: item.brandId,
          brand: item?.Brand?.toString()?.trim() ?? '',
          category: item?.Category?.toString()?.trim() ?? '',
          categoryId: item.categoryId,
          colors: ["#eeeeee"],
          colorName: "Gray",
          colorCode: "#eeeeee",
          description: item?.Description?.toString()?.trim() ?? '',
          discountPercent: discountPercent,
          discountValue: discountValue,
          gender: item?.Gender?.toString()?.trim() ?? '',
          gstRate: item?.GSTRATE,
          hsnsac: item?.HSNCODE?.toString()?.trim() ?? '',
          inventory: inventory,
          isActive: true,
          margin: 0.00,
          mrp: 0.00,
          name: item?.name?.toString()?.trim() ?? '',
          packOf: item.Pack?.toString()?.trim() ?? '',
          packagingId: 1,
          productId: prodId || 0,
          productTags: [
            'Garments Hub',
            'Summer Cloths'
          ],
          publish: true,
          season: item.Season?.toString()?.trim() ?? '',
          seasonId: item.seasonId,
          size: item['SizeGroups']?.toString()?.trim() ?? '',
          sizeId: item.sizeId || 0,
          sizeSKU: item.SizeSKU?.toString()?.trim() ?? '',
          sku: item.SKU?.toString()?.trim() ?? '',
          status: 0,
          styleNo: item?.StyleNo?.toString()?.trim() ?? '',
          unitPrice: item.UnitPrice || 1.00,
          buyingPrice: buyingPrice,
          variantId: variantId,
          externalSku: '',
        };
        console.log(product);
        products.push(product)

      });

      setExcelProductList(products);
      setIsLoading(false);
      console.table('excelData', excelData);
    }
  }


  async function callApiForRecords() {

    setIsSaving(true);
    setSaveProgress({ current: 0, total: excelProductList.length });
    for (let i = 0; i < excelProductList.length; i++) {
      const product = excelProductList[i];
      product.status = 3; // processing
      setExcelProductList([...excelProductList]);
      await new Promise(resolve => setTimeout(resolve, 1500));
      console.log('productId', product.productId, new Date(), 'start');

      if (product.productId == 0) {
        try {
          console.log('productId', product.productId, new Date());

          // make a copy of product object
          const productData = {
            attributes: product.attributes,
            availableFromDate: product.availableFromDate,
            availableToDate: product.availableToDate,
            brandId: product.brandId,
            categoryId: product.categoryId,
            colors: product.colors,
            description: product.description?.trim(),
            gender: product.gender?.trim(),
            gstRate: product.gstRate,
            hsnsac: product.hsnsac?.trim(),
            isActive: product.isActive,
            name: product.name?.trim(),
            packagingId: product.packagingId,
            productTags: product.productTags,

            publish: product.publish,
            seasonId: product.seasonId,
            sku: product.sku?.trim(),
            styleNo: product.styleNo?.trim(),
          };

          console.log('Product-Request', productData);

          const response = await addProduct(productData);
          console.log('Product-response', response);
          const newProductId = response.data?.id;
          product.productId = newProductId;
          console.log('variant productId', product.productId, new Date());
          await saveProductVariant(product);
          //update the status of product in excelProductList
          product.status = 1;
          setExcelProductList([...excelProductList]);

          // find all the variants of the product and update the productId in the variant
          // update the productId in the excelProductList

          const variants = excelProductList.filter((p: any) => p.productId === 0 && p.sku === product.sku);
          console.log('variants', variants);
          variants.forEach((variant: any) => {
            variant.productId = newProductId;
          });

          setExcelProductList([...excelProductList]);


        } catch (error: any) {
          console.log('Product-Error-Response', error.response);
          product.status = 2;
          setExcelProductList([...excelProductList]);
        }

      } else {
        product.status = 1; // completed
        await saveProductVariant(product);
        setExcelProductList([...excelProductList]);
      }
      setSaveProgress({ current: i + 1, total: excelProductList.length });
    }
    
    setIsSaving(false);
   
  }

  useEffect(() => {
    if (saveProgress.total > 0 && saveProgress.current === saveProgress.total) {
      setIsSaving(false);
      alert('Products uploaded successfully');
    }
  }, [saveProgress.total, saveProgress.current]);

  const saveProductVariant = async (product: any) => {
    console.log('variant productId', product.productId, new Date());

    try {

      const variantProduct = {
        id: product.variantId,
        productId: product.productId,
        sizeId: product.sizeId,
        colorCode: "#eeeeee",
        colorName: "Gray",
        unitPrice: product.unitPrice,
        packOf: product.packOf,
        discountPercent: product.discountPercent,
        discountValue: product.discountValue,
        mrp: "0.00",
        margin: "0.00",
        inventory: product.inventory,
        sku: product.sizeSKU?.trim(),
        externalSku: "",
        isActive: true,
        buyingPrice: product.buyingPrice,
        syncedWithERP: false,
      }

      if (product.variantId == 0) {
        delete variantProduct.id;
        await addProductVariant(variantProduct);
      } else {
        try {
          await updateProductVariant(variantProduct);
        } catch (e) {
          console.log(e);
        }
      }
    }
    catch (error: any) {
      console.log('Product-Error-Response', error.response);
    }
  }


  const runningStatus = (status: number) => {
    switch (status) {
      case 1:
        return 'Success';
      case 0:
        return '';
      case 2:
        return 'Failed';
      case 3:
        return <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" style={{ marginLeft: '35%' }} />;
      default:
        return '';
    }
  }

  const runningStatusClass = (status: number) => {
    switch (status) {
      case 1:
        return 'text-green-500';
      case 0:
        return '';
      case 2:
        return 'text-red-500';
      case 3:
        return 'text-blue-500';
      default:
        return '';
    }
  }

  const borderStyle = {
    border: '1px solid'
  }


  return (

    <div style={{ marginTop: 10 }}>
      <div className="flex items-center gap-2">
        <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
        {isLoading && <Loader2 className="size-8 animate-spin shrink-0" />}
        
        {excelProductList?.length > 0 && (
          <>
     <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            onClick={() => { callApiForRecords(); }}
            disabled={isSaving}
          >
            {isSaving ? "Uploading products..." : "Upload Products"}
            </button>
            {isSaving && (
              <>
                <Loader2 className="size-8 animate-spin shrink-0" />
                <span className="ml-1">
                  {saveProgress.total > 0 ? Math.round((saveProgress.current / saveProgress.total) * 100) : 0}% completed
                </span>
              </>
            )}
          </>
        )}
      </div>
      {excelProductList?.length > 0 && (
          <table border={1} style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid', marginTop: 10 }}>
            <thead>
              <tr>
                <th style={borderStyle}>ProdID</th>
                <th style={borderStyle}>Product Name</th>
                <th style={borderStyle}>Description</th>
                <th style={borderStyle}>SKU</th>
                <th style={borderStyle}>Brand</th>
                <th style={borderStyle}>Gender</th>
                <th style={borderStyle}>Category</th>
                <th style={borderStyle}>Buying Price</th>
                <th style={borderStyle}>Season</th>
                <th style={borderStyle}>Size</th>
                <th style={borderStyle}>SizeSKU</th>
                <th style={borderStyle}>Pack</th>
                <th style={borderStyle}>HSNSAC</th>
                <th style={borderStyle}>GSTRate</th>
                <th style={borderStyle}>UnitPrice</th>
                <th style={borderStyle}>Discount %</th>
                <th style={borderStyle}>Discount Value</th>
                <th style={borderStyle}>Inventory</th>
                <th style={borderStyle}>Status</th>
                {/* <th style={borderStyle}>Publish</th>
              <th style={borderStyle}>Active</th> */}
              </tr>
            </thead>
            <tbody>
              {excelProductList.map((row, index) => (
                <tr key={index}>
                  <td style={borderStyle} className={row.productId === 0 || row.productId === "" ? "text-blue-500" : ""}>{row.productId}</td>
                  <td style={borderStyle} className={row?.name?.length === 0 || row?.name === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.name}</td>
                  <td style={borderStyle} className={row?.description?.length === 0 || row?.description === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.description}</td>
                  <td style={borderStyle} className={row?.sku === null || row?.sku === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.sku}</td>
                  <td style={borderStyle} className={row.brandId === 0 || row.brandId === null ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.brand}</td>
                  <td style={borderStyle} className={row.gender === 0 || row.gender === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.gender}</td>
                  <td style={borderStyle} className={row.categoryId === 0 || row.categoryId === null ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.category}</td>
                  <td style={borderStyle} className={row.buyingPrice === 0 || row.buyingPrice === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.buyingPrice}</td>
                  <td style={borderStyle} className={row.seasonId === 0 || row.seasonId === null ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.season}</td>
                  <td style={borderStyle} className={row.sizeId === 0 || row.sizeId === null ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.size}</td>
                  <td style={borderStyle} className={row.sizeSKU === null ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.sizeSKU}</td>
                  <td style={borderStyle} className={row.packOf === 0 || row.packOf === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.packOf}</td>
                  <td style={borderStyle} className={row.hsnsac === 0 || row.hsnsac === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.hsnsac}</td>
                  <td style={borderStyle} className={row.gstRate === 0 || row.gstRate === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.gstRate}</td>
                  {/* <td style={borderStyle} >{row.mrp}</td> */}
                  <td style={borderStyle} className={row.unitPrice === 0 || row.unitPrice === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.unitPrice}</td>
                  {/* <td style={borderStyle} >{row.margin}</td> */}
                  <td style={borderStyle} >{row.discountPercent}</td>
                  <td style={borderStyle} >{row.discountValue}</td>
                  <td style={borderStyle} >{row.inventory}</td>
                  <td style={borderStyle} className={runningStatusClass(row.status)}>
                    {runningStatus(row.status)}
                  </td>
                  {/* <td style={borderStyle} className={row.publish === 0 || row.publish === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.publish}</td>
                <td style={borderStyle} className={row.isActive === 0 || row.isActive === "" ? "bg-red-500 border-red-500 text-white-500" : ""}>{row.isActive}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
      )}
    </div>
  );
}
